import { gql } from '@apollo/client';

const QUERY = gql`
  query ListTransactionGroups($externalId: Int!, $externalType: String!) {
    listTransactionGroups(external_id: $externalId, external_type: $externalType) {
      id
      amount
      amountRefunded
      feeAmount
      netAmount
      payment {
        id
        amount
        date
        description
        netAmount
        appliedFeeAmount
        paymentMethodAccountName
        paymentMethodLast4
        paymentMethodType
        paymentMethodAccountType
        status
        type
      }
      refundable
      refunds {
        id
        amount
        insertedAt
        paymentId
        processorAccountId
        processorRefundId
        reason
        refundedFeeAmount
        netAmount
        status
        updatedAt
        userId
      }
      chargebacks {
        id
        status
        currency
        amount
        processorTransferReversalId
        depositDate
        processorAccountId
        payoutId
        paymentId
        insertedAt
        updatedAt
      }
      status
    }
  }
`;

export default QUERY;
